<div class="ibox detailed-view-ibox">
    <div class="detailed-view-header">
        <div class="item-name">{{itemData.name}}</div>
        <span class="close-detailed-view" (click)="close()">×</span>
    </div>

    <div class="detailed-view-body">
        <div class="detailed-view__more-info">
            <form #form="ngForm" submittable (ngSubmit)="onSubmit(form)">
                <div class="m-t-xs">
                    <input-field name="name"
                                 [title]="'User Role Name'"
                                 [noEdit]="!isCanEdit"
                                 (update)="updateProperty({name: form.value.name})"
                                 [ngModel]="itemData.name">
                    </input-field>

                </div>

                <div class="m-b-xs">
                    <select-field name="corporationNumberId"
                                  [title]="'Corporation #'"
                                  [data]="userRoleService.corporationNumberList"
                                  [noEdit]="!isCanEdit"
                                  (update)="updateProperty({corporationNumberId: form.value.corporationNumberId})"
                                  [ngModel]="itemData.corporationNumberId">
                    </select-field>
                </div>

                <table class="user-role-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                <div class="display-flex">
                                    <label class="img-checkbox">
                                        <input id="readCheckAll"
                                               type="checkbox"
                                               name="readCheckAll"
                                               [disabled]="isColumnCheckboxDisabled()"
                                               (change)="checkEntireColumnPermissions($event, 'r')"
                                               [ngModel]="allInColumnAreChecked('r')">
                                        <label for="readCheckAll"><svg-checked></svg-checked></label>
                                    </label>
                                    Read
                                </div>
                            </th>
                            <th>
                                <div class="display-flex">
                                    <label class="img-checkbox">
                                        <input id="createCheckAll"
                                               type="checkbox"
                                               name="createCheckAll"
                                               [disabled]="isColumnCheckboxDisabled()"
                                               (change)="checkEntireColumnPermissions($event, 'c')"
                                               [ngModel]="allInColumnAreChecked('c')">
                                        <label for="createCheckAll"><svg-checked></svg-checked></label>
                                    </label>
                                    Create
                                </div>
                            </th>
                            <th>
                                <div class="display-flex">
                                    <label class="img-checkbox">
                                        <input id="updateCheckAll"
                                               type="checkbox"
                                               name="updateCheckAll"
                                               [disabled]="isColumnCheckboxDisabled()"
                                               (change)="checkEntireColumnPermissions($event, 'u')"
                                               [ngModel]="allInColumnAreChecked('u')">
                                        <label for="updateCheckAll"><svg-checked></svg-checked></label>
                                    </label>
                                    Update
                                </div>
                            </th>
                            <th>
                                <div class="display-flex">
                                    <label class="img-checkbox">
                                        <input id="deleteCheckAll"
                                               type="checkbox"
                                               name="deleteCheckAll"
                                               [disabled]="isColumnCheckboxDisabled()"
                                               (change)="checkEntireColumnPermissions($event, 'd')"
                                               [ngModel]="allInColumnAreChecked('d')">
                                        <label for="deleteCheckAll"><svg-checked></svg-checked></label>
                                    </label>
                                    Delete
                                </div>
                            </th>
                            <th>
                                <div class="display-flex">
                                    <label class="img-checkbox">
                                        <input id="approveCheckAll"
                                               type="checkbox"
                                               name="approveCheckAll"
                                               [disabled]="isColumnCheckboxDisabled()"
                                               (change)="checkEntireColumnPermissions($event, 'a')"
                                               [ngModel]="allInColumnAreChecked('a')">
                                        <label for="approveCheckAll"><svg-checked></svg-checked></label>
                                    </label>
                                    Approve
                                </div>
                            </th>
                            <th>
                                <div class="display-flex">
                                    <label class="img-checkbox">
                                        <input id="settingsCheckAll"
                                               type="checkbox"
                                               name="settingsCheckAll"
                                               [disabled]="isColumnCheckboxDisabled()"
                                               (change)="checkEntireColumnPermissions($event, 's')"
                                               [ngModel]="allInColumnAreChecked('s')">
                                        <label for="settingsCheckAll"><svg-checked></svg-checked></label>
                                    </label>
                                    Settings
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of serviceNames; let i = index">
                        <td class="display-flex">
                            <label class="img-checkbox">
                                <input id="{{item+'CheckAll'}}"
                                       type="checkbox"
                                       name="{{item+'CheckAll'}}"
                                       (change)="checkAllPermissions($event, item)"
                                       [disabled]="!userRoleService.account.canUpdate('auth') || (isCurrentRole && item === 'auth')"
                                       [ngModel]="allPermissionsAreChecked(item)">
                                <label for="{{item+'CheckAll'}}"><svg-checked></svg-checked></label>
                            </label>
                            {{ adm.allServices[item] }}
                            <i *ngIf="item == 'amenity' && userRoleService.account.canUpdate('auth')"
                               class="fa fa-arrow-right mtv-primary-color m-t-xs m-l-sm clickable"
                               (click)="userRoleService.showAmenityPermissionsTable = true;">
                            </i>
                        </td>
                        <td>
                            <label class="img-checkbox">
                                <input id="{{item+':'+'r'}}"
                                       type="checkbox"
                                       name="{{item+':'+'r'}}"
                                       [disabled]="!userRoleService.account.canUpdate('auth') || item === 'bldn' || (isCurrentRole && item === 'auth')"
                                       (change)="selectRead($event, item)"
                                       [(ngModel)]="services[item].r">
                                <label for="{{item+':'+'r'}}"><svg-checked></svg-checked></label>
                            </label>
                        </td>
                        <td>
                            <label class="img-checkbox">
                                <input id="{{item+':'+'c'}}"
                                       type="checkbox"
                                       name="{{item+':'+'c'}}"
                                       [disabled]="!userRoleService.account.canUpdate('auth') || !services[item].r || (isCurrentRole && item === 'auth')"
                                       (click)="selectUpdate($event, item, 'c')"
                                       [(ngModel)]="services[item].c">
                                <label for="{{item+':'+'c'}}"><svg-checked></svg-checked></label>
                            </label>
                        </td>
                        <td>
                            <label class="img-checkbox">
                                <input id="{{item+':'+'u'}}"
                                       type="checkbox"
                                       name="{{item+':'+'u'}}"
                                       [disabled]="!userRoleService.account.canUpdate('auth') || !services[item].r || (isCurrentRole && item === 'auth')"
                                       (click)="selectUpdate($event, item, 'u')"
                                       [(ngModel)]="services[item].u">
                                <label for="{{item+':'+'u'}}"><svg-checked></svg-checked></label>
                            </label>
                        </td>
                        <td>
                            <label class="img-checkbox">
                                <input id="{{item+':'+'d'}}"
                                       type="checkbox"
                                       name="{{item+':'+'d'}}"
                                       [disabled]="!userRoleService.account.canUpdate('auth') ||
                                                   !services[item].c || !services[item].u ||
                                                   (isCurrentRole && item === 'auth')"
                                       [(ngModel)]="services[item].d">
                                <label for="{{item+':'+'d'}}"><svg-checked></svg-checked></label>
                            </label>
                        </td>
                        <td>
                            <label class="img-checkbox" *ngIf="item == 'amenity' || item == 'parking_pass'">
                                <input id="{{item+':'+'a'}}"
                                       type="checkbox"
                                       name="{{item+':'+'a'}}"
                                       [disabled]="!userRoleService.account.canUpdate('auth') ||
                                                   (!services[item].c || !services[item].u) ||
                                                   (isCurrentRole && item === 'auth')"
                                       [(ngModel)]="services[item].a">
                                <label for="{{item+':'+'a'}}"><svg-checked></svg-checked></label>
                            </label>
                        </td>
                        <td>
                            <label class="img-checkbox"
                                   *ngIf="item == 'amenity' || item == 'parking_pass' || item == 'parcels' || item == 'bldn' || item == 'key_log' || item == 'service_request' || item == 'pass_on_log' || item == 'inc_report' || item == 'email_merge' || item == 'sms'">
                                <input id="{{item+':'+'s'}}"
                                       type="checkbox"
                                       name="{{item+':'+'s'}}"
                                       [disabled]="!userRoleService.account.canUpdate('auth') ||
                                                   (!services[item].c || !services[item].u) ||
                                                   (isCurrentRole && item === 'auth')"
                                       [(ngModel)]="services[item].s">
                                <label for="{{item+':'+'s'}}"><svg-checked></svg-checked></label>
                            </label>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="btn-group m-b-md m-l-sm" *ngIf="userRoleService.account.canDelete('auth') && !isCurrentRole">
                    <a data-toggle="dropdown" class="btn btn-default btn-sm dropdown-toggle">
                        Actions <span class="caret"></span>
                    </a>
                    <ul class="dropdown-menu">
                        <li><a (click)="remove()">Delete</a></li>
                    </ul>
                </div>
                <div *ngIf="userRoleService.account.canUpdate('auth')" class="confirmation-box">
                    <p class="col-sm-8 alert-text" *ngIf="checkForChanges()">
                        Please note that permissions have been modified and will affect all users with this user role.
                    </p>
                    <button class="btn btn-primary btn-w-m submit-btn" type="submit">Save</button>
                </div>
                <div class="user-role-users-row" *ngIf="itemData.usersData.length > 0">
                    <div class="col-md-2">
                        <label>Users:</label>
                    </div>
                    <div class="col-md-10">
                        <div *ngFor="let user of itemData.usersData; trackBy: trackByFn" >
                            {{user.fullName}} ({{user.email}})
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/user-role/item-view/item-view.component.html